// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resource{display:block;align-self:flex-start}.resource__description{margin-bottom:0;color:rgba(9,36,51,.65)}.resource__title{margin-bottom:12px}@media (max-width:767px){.resource__title{margin-bottom:8px}}", ""]);
// Exports
module.exports = exports;
